module.exports = __webpack_public_path__ + "static/img/google_sign_in.75a7cb04.png";